module.exports = __webpack_public_path__ + "50705735775e60217db89971f0116c90.svg";